import React from "react";

interface InfoBoxProps {
  onGoBack: () => void;
  children: React.ReactNode;
}

/**
 * Box to display some details, with a back button
 */
export function InfoBox(props: InfoBoxProps) {
  return (
    <div>
      <div>{props.children}</div>
      <button
        className="secondary-btn"
        style={{ marginTop: 15 }}
        onClick={props.onGoBack}
      >
        Go Back
      </button>
    </div>
  );
}
